import { providePrimeNG } from 'primeng/config';
import { LanguageEnum } from '@/app/shared/enums/language.enum';
import { ApiInterceptor } from '@/app/core/interceptors/api.interceptor';
import { AuthInterceptor } from '@/app/core/interceptors/auth.interceptor';
import { ErrorInterceptor } from '@/app/core/interceptors/error.interceptor';
import { AppTranslateLoader } from '@/app/core/translate/app-translate.loader';
import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { AuthRefreshInterceptor } from '@/app/core/interceptors/auth-refresh.interceptor';

import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HttpClient, withInterceptors, provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { SvgIconModule } from '@/app/shared/components/ui/svg-icon/svg-icon.module';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([ApiInterceptor, AuthInterceptor, AuthRefreshInterceptor, ErrorInterceptor])),
    importProvidersFrom(
      SvgIconModule.forRoot({
        spriteUrl: '/assets/images/icons/sprite.svg',
      }),
    ),
    provideAnimationsAsync(),
    providePrimeNG(),
    provideTranslateService({
      defaultLanguage: LanguageEnum.En,

      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => new AppTranslateLoader(http),
        deps: [HttpClient],
      },
    }),
  ],
};
